import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentConfig, ENV_CONFIG } from 'src/app/core/enviroment-config';
import { BaseService } from 'src/app/core/service/abstract/base.service';

@Injectable({
  providedIn: 'root'
})
export class TotpDeviceApiService extends BaseService {
  constructor(
    protected http: HttpClient,
    @Inject(ENV_CONFIG) config: EnvironmentConfig
  ) {
    super(config);
  }

  setupOTP(data: { username: string; otp_code: string }) {
    const path = this.getPath('portal/auth/otp_device/setup/');
    return this.http.post(path, data, { responseType: 'blob' });
  }

  confirmOtp(data: { username: string; password: string }) {
    const path = this.getPath('portal/auth/otp_device/confirm/');

    return this.http.post<{ key: string }>(path, data, {
      headers: this.createHeaders(),
    });
  }

  disableOtp() {
    const path = this.getPath('portal/auth/otp_device/disable/');
    return this.http.post<{ key: string }>(path, {}, {
      headers: this.createHeaders(),
    })
  }
}